import { observer } from 'mobx-react-lite'
import { ProfileDropdown } from '@/features/shell/global-navigation/Navigation/ProfileDropdown'
import { type GlobalNavigationViewModel } from '@/features/shell/global-navigation/GlobalNavigationViewModel'

export interface ProfileDropdownContainerProps {
  vm: GlobalNavigationViewModel
}

export const ProfileDropdownContainer = observer(
  function ProfileDropdownContainer({ vm }: ProfileDropdownContainerProps) {
    return (
      <ProfileDropdown
        visible={vm.profileMenu.showing}
        onRequestClose={vm.profileMenu.close}
        avatar={{
          avatar: vm.member.avatar,
          avatarFallback: vm.member.avatarFallback,
          displayName: vm.member.displayName,
        }}
        displayName={vm.member.displayName}
        email={vm.member.email}
        menuItems={vm.customLinks}
        shouldShowBilling={vm.shouldShowBilling}
        canEnrollInMultiFactorAuth={vm.canEnrollInMultiFactorAuth}
        onEnrollInMultiFactorAuth={vm.enrollInMultiFactorAuth}
        onAddNewWorkspace={vm.addNewWorkspace}
        canGoToHq={vm.canGoToHq}
        onGoToHq={vm.goToHq}
        canViewPayoutsAdmin={vm.canViewPayoutsAdmin}
        canSeeAdminView={vm.canSeeAdminView}
        canManageJobScopeChangeRequest={vm.canManageJobScopeChangeRequest}
        canManageBookkeeping={vm.canManageBookkeeping}
        canSeeStaffingManager={vm.canSeeStaffingManager}
        canManageServices={vm.canManageServices}
        canManageAccountMergeRequests={vm.canManageAccountMergeRequests}
        isFirmAdmin={vm.isFirmAdmin}
        isPro={vm.isPro}
      />
    )
  },
)
